import { PauseIcon, PlayIcon } from '@heroicons/react/24/solid';

import { toggle } from '../radioEngine';
import { useRadioStore } from '../radio.store';

interface PlayButtonProps {
  /** `hero` - duży przycisk z podpisem na stronie głównej; `compact` - sama ikona. */
  variant?: 'hero' | 'compact';
}

export function PlayButton({ variant = 'hero' }: PlayButtonProps): JSX.Element {
  const status = useRadioStore((state) => state.status);
  const busy = status === 'loading' || status === 'reconnecting';
  const active = status === 'playing' || busy;
  const Icon = active ? PauseIcon : PlayIcon;

  return (
    <button
      type="button"
      className={variant === 'hero' ? 'radio-play' : 'radio-play radio-play--compact'}
      data-active={active}
      onClick={toggle}
      aria-label={active ? 'Pauza' : 'Słuchaj Radia Adamowo'}
      aria-busy={busy}
    >
      <Icon aria-hidden="true" />
      {variant === 'hero' && <span>{active ? 'Pauza' : 'Słuchaj'}</span>}
    </button>
  );
}
